import {
  ASSET_STATUS_LIST, ASSET_STATUS_LIST_SUCCESS, ASSET_STATUS_LIST_FAILURE,
  ASSET_STATUS_DATA, ASSET_STATUS_DATA_SUCCESS, ASSET_STATUS_DATA_FAILURE,
  ASSET_STATUS_CREATE, ASSET_STATUS_CREATE_SUCCESS, ASSET_STATUS_CREATE_FAILURE,
  ASSET_STATUS_UPDATE, ASSET_STATUS_UPDATE_SUCCESS, ASSET_STATUS_UPDATE_FAILURE,
  ASSET_STATUS_DELETE, ASSET_STATUS_DELETE_SUCCESS, ASSET_STATUS_DELETE_FAILURE,
} from "./actionType";

const initialState = {
  assetStatusList: [], assetStatusListLoading: false, assetStatusListError: null,
  assetStatusData: [], assetStatusDataLoading: false, assetStatusDataError: null,
  assetStatusCreate: [], assetStatusCreateLoading: false, assetStatusCreateError: null,
  assetStatusUpdate: [], assetStatusUpdateLoading: false, assetStatusUpdateError: null,
  assetStatusDelete: [], assetStatusDeleteLoading: false, assetStatusDeleteError: null,
};

const AssetStatus = (state = initialState, action) => {
  switch (action.type) {
    case ASSET_STATUS_LIST:         return { ...state, assetStatusListLoading: true, assetStatusListError: null };
    case ASSET_STATUS_LIST_SUCCESS: return { ...state, assetStatusList: action.payload, assetStatusListLoading: false, assetStatusListError: null };
    case ASSET_STATUS_LIST_FAILURE: return { ...state, assetStatusList: [], assetStatusListLoading: false, assetStatusListError: action.payload };

    case ASSET_STATUS_DATA:         return { ...state, assetStatusDataLoading: true, assetStatusDataError: null };
    case ASSET_STATUS_DATA_SUCCESS: return { ...state, assetStatusData: action.payload, assetStatusDataLoading: false, assetStatusDataError: null };
    case ASSET_STATUS_DATA_FAILURE: return { ...state, assetStatusData: [], assetStatusDataLoading: false, assetStatusDataError: action.payload };

    case ASSET_STATUS_CREATE:         return { ...state, assetStatusCreateLoading: true, assetStatusCreateError: null };
    case ASSET_STATUS_CREATE_SUCCESS: return { ...state, assetStatusCreate: action.payload, assetStatusCreateLoading: false, assetStatusCreateError: null };
    case ASSET_STATUS_CREATE_FAILURE: return { ...state, assetStatusCreate: [], assetStatusCreateLoading: false, assetStatusCreateError: action.payload };

    case ASSET_STATUS_UPDATE:         return { ...state, assetStatusUpdateLoading: true, assetStatusUpdateError: null };
    case ASSET_STATUS_UPDATE_SUCCESS: return { ...state, assetStatusUpdate: action.payload, assetStatusUpdateLoading: false, assetStatusUpdateError: null };
    case ASSET_STATUS_UPDATE_FAILURE: return { ...state, assetStatusUpdate: [], assetStatusUpdateLoading: false, assetStatusUpdateError: action.payload };

    case ASSET_STATUS_DELETE:         return { ...state, assetStatusDeleteLoading: true, assetStatusDeleteError: null };
    case ASSET_STATUS_DELETE_SUCCESS: return { ...state, assetStatusDelete: action.payload, assetStatusDeleteLoading: false, assetStatusDeleteError: null };
    case ASSET_STATUS_DELETE_FAILURE: return { ...state, assetStatusDelete: [], assetStatusDeleteLoading: false, assetStatusDeleteError: action.payload };

    default: return state;
  }
};

export default AssetStatus;